export const environment = {
  production: false,
  hml: true,
  api: {
    DepartamentoProdutos: 'https://api-hml.cea.com.br/minhacea/departamentoprodutos/v1',
    Produtos: 'https://api-hml.cea.com.br/minhacea/produtos/v1',
    Pedidos: 'https://api-hml.cea.com.br/minhacea/pedidos/v1',
    GestaoAcesso: 'https://api-hml.cea.com.br/minhacea/gestaoacesso/v1',
    CalculoLucro: 'https://api-hml.cea.com.br/minhacea/calculolucro/v1',
    Backend: 'https://api-hml.cea.com.br/minhacea/backend/v1',
    Campanhas: 'https://api-hml.cea.com.br/minhacea/campanhas/v1',
    Arquivo: 'https://api-hml.cea.com.br/minhacea/arquivo/v1',
    Pagamentos: 'https://api-hml.cea.com.br/minhacea/pagamentos/v1',
    Afiliados: 'https://api-hml.cea.com.br/minhacea/afiliados/v1',
    GeradorPdf: 'https://api-hml.cea.com.br/minhacea/geradorpdf/v1',
    GeradorLink: 'https://api-hml.cea.com.br/minhacea/link/v1'
  },
  urlCloudFront: 'https://d1wrkv97pec7t.cloudfront.net',
  oauth: 'https://api-hml.cea.com.br/oauth/v2/access-token',
  captchaId: '6Le_UrQtAAAAACFPmZ4oqMKCRZytIgyF0mhan3gp',
  MceaKey:
    'NWQ4YjU3ZTItYjE0Ni0zZmQ2LThmZGMtZTFjZWY4MDQ4YTk1OmViMGFkYjFhLTMwYWYtMzFjZi1iNmJlLTdlY2MxNWQ0ZGExNQ==',
  gtm: {
    send: true,
    tag: 'GTM-MXRGTNK',
    app: 'minhacea'
  },
  azureConfig: {
    clientId: '4e9e77c0-8074-4203-b454-8cd55cdead91',
    authority: 'https://login.microsoftonline.com/97e05be6-37b8-44e4-a9d5-4bd3fd6d05fe',
    redirectUri: window.location.origin,
    scopes: ['user.read']
  },
  chatBot: 'https://chatbot-cea.dev.cea-ecommerce.com.br'
};
